<template>
  <div id="app" v-if="showH5 == true">
    <div class="download-layer" v-show="showTip == true">
      <img class="download-layer-img" src="./assets/Montmorillonite.png" alt="" srcset="" />
    </div>

    <router-view />
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 下载蒙层
      showTip: false,

      showH5: false,
    };
  },
  created() {
    //平台、设备和操作系统
    var system = {
      win: false,
      mac: false,
      xll: false,
    };
    //检测平台
    var p = navigator.platform;
    system.win = p.indexOf("Win") == 0;
    system.mac = p.indexOf("Mac") == 0;
    system.x11 = p == "X11" || p.indexOf("Linux") == 0;

    if (system.win || system.mac || system.xll) {
      //PC端
     //  window.location.href = "https://wflike.com/#/";
        this.showH5 = true;
    } else {
      //移动端跳转的链接
      this.showH5 = true;
    }

    this.APPshow();
  },
  mounted() {
    window.onload = function () {
      document.addEventListener("touchstart", function (e) {
        if (e.touches.length > 1) {
          e.preventDefault();
        }
      });
      document.addEventListener("gesturestart", function (e) {
        e.preventDefault();
      });
    };
  },
  methods: {
    APPshow() {
      var ua = navigator.userAgent.toLowerCase();
      console.log(navigator.userAgent.toLowerCase());

      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        this.showTip = true;
      } else if (ua.indexOf(" qq") > -1 && ua.indexOf("mqqbrowser") > 0) {
        //qq内置浏览器
        this.showTip = true;
      } else {
        this.showTip = false;
      }
    },
  },
};
</script>

<style lang="less">
body {
  margin: 0;
  padding: 0;
}

.download-layer {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99999;

  .download-layer-img {
    width: 100%;
    height: 100%;
    z-index: 10;
    left: 0;
    top: 0;
  }
}
</style>
